'use client';

import { styled } from '@linaria/react';
import HotPopTopicTrackingList from '@fe-news/components/molecules/Member/HotPopTopicTrackingList';
import PopTopicInfiniteList from '@fe-news/components/molecules/MyPopTopicContent/PopTopicInfiniteList';
import MyTrackDateProvider from '@fe-news/context/my-track-date-provider';
import { useMyPopTopic } from '@fe-news/context/my-pop-topic-provider';
import Image from 'next/image';
import MemberButton from '@fe-news/components/atoms/Member/MemberButton';
import Link from 'next/link';
import HotPopTopicCard from '@fe-news/components/molecules/MyPopTopicContent/HotPopTopicCard';
import HotPopTopicCardLazy from '@fe-news/components/molecules/MyPopTopicContent/HotPopTopicCardLazy';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import MyPopTopicContentSkeleton from './MyPopTopicContentSkeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const NoTrackingContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  row-gap: 32px;
`;

const NoTrackingHint = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #000;
  padding-bottom: 63px;
  border-bottom: dashed 2px #e2e8f1;

  h3 {
    margin-top: 24px;
    margin-bottom: 16px;
  }
`;

const ButtonContainer = styled.div`
  padding: 0 22px;

  a {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 16px;
  }
`;

const onClickHotPopTopic = () => {
  const gtmEvent = {
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
    [GTMEventKey.SECTION]: 'News_Category_我的追蹤',
    [GTMEventKey.CLICK_ITEM]: `追蹤的時事＿熱門時事`
  };
  sendGTM(gtmEvent);
};

const MyPopTopicContent = ({ children }: { children: React.ReactNode }) => {
  const { myCollectionDataItemsIdArray, isLoading, isLoggedIn } = useMyPopTopic();

  if (isLoading && isLoggedIn) {
    return <MyPopTopicContentSkeleton />;
  }

  return (
    <Container>
      <MyTrackDateProvider>
        {myCollectionDataItemsIdArray?.length === 0 && (
          <NoTrackingContainer>
            <NoTrackingHint>
              <Image src='/assets/icons/no-pop-topic-data.svg' alt='no-data' width={162} height={150} unoptimized />
              <h3>您尚未有追蹤的時事</h3>
              <MemberButton aria-label='go-to-pop-topic' style={{ width: 'fit-content', padding: '7px 0px' }}>
                <ButtonContainer>
                  <Link href='/poptopic' onClick={onClickHotPopTopic} prefetch={false}>
                    熱門時事
                    <Image
                      src='/assets/icons/icon-arrow-right-white.svg'
                      alt='arrow-right'
                      width={16}
                      height={16}
                      unoptimized
                    />
                  </Link>
                </ButtonContainer>
              </MemberButton>
            </NoTrackingHint>
            <HotPopTopicTrackingList renderCard={HotPopTopicCard} renderCardLazy={HotPopTopicCardLazy}>
              {children}
            </HotPopTopicTrackingList>
          </NoTrackingContainer>
        )}
        {myCollectionDataItemsIdArray?.length > 0 && <PopTopicInfiniteList />}
      </MyTrackDateProvider>
    </Container>
  );
};

export default MyPopTopicContent;
